var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Button, Slider, Typography, Grid, TextareaAutosize, Chip } from "@material-ui/core";
import { OverlayBox } from "./Overlay";
var StyledOutput = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 5px;\n  display: table-cell;\n  min-height: 100px;\n  overflow: auto;\n  white-space: pre-wrap;\n"], ["\n  padding: 5px;\n  display: table-cell;\n  min-height: 100px;\n  overflow: auto;\n  white-space: pre-wrap;\n"])));
var HeaderWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 1px 25px;\n  background: #4caf50;\n  font-family: Roboto Slab, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,\n    Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji,\n    Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;\n  color: white !important;\n  width: 100%;\n"], ["\n  padding: 1px 25px;\n  background: #4caf50;\n  font-family: Roboto Slab, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,\n    Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji,\n    Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;\n  color: white !important;\n  width: 100%;\n"])));
var FooterWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-top: 1px dashed black;\n  width: 100%;\n"], ["\n  border-top: 1px dashed black;\n  width: 100%;\n"])));
var FeedbackTitle = styled(Typography)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  && {\n    font-size: 1.5rem;\n    padding: 9px 5px;\n    font-weight: 500;\n    color: white !important;\n  }\n"], ["\n  && {\n    font-size: 1.5rem;\n    padding: 9px 5px;\n    font-weight: 500;\n    color: white !important;\n  }\n"])));
var CloseButton = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  cursor: pointer;\n  font-size: 2rem;\n  float: right;\n"], ["\n  cursor: pointer;\n  font-size: 2rem;\n  float: right;\n"])));
var FeedbackText = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  && {\n    font-size: 1rem;\n    padding: 9px 5px;\n  }\n"], ["\n  && {\n    font-size: 1rem;\n    padding: 9px 5px;\n  }\n"])));
var StyledChip = styled(Chip)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  && {\n    color: white;\n    margin-right: 10px;\n  }\n"], ["\n  && {\n    color: white;\n    margin-right: 10px;\n  }\n"])));
var StyledButton = styled(function (props) {
  return React.createElement(Button, __assign({
    variant: "contained"
  }, props));
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin: 5px !important;\n"], ["\n  margin: 5px !important;\n"])));
var Question = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  margin: 20px;\n"], ["\n  margin: 20px;\n"])));
var StyledSpan = styled(Typography)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  && {\n    margin: 15px 10px 5px 10px;\n    font-weight: bold;\n  }\n"], ["\n  && {\n    margin: 15px 10px 5px 10px;\n    font-weight: bold;\n  }\n"])));
var FeedbackForm = function FeedbackForm(_a) {
  var awardedPoints = _a.awardedPoints,
    onSubmitFeedback = _a.onSubmitFeedback,
    onClose = _a.onClose,
    feedbackQuestions = _a.feedbackQuestions,
    solutionUrl = _a.solutionUrl;
  var t = useTranslation()[0];
  var _b = useState((feedbackQuestions === null || feedbackQuestions === void 0 ? void 0 : feedbackQuestions.map(function (question) {
      if (question.kind === "text") {
        return __assign(__assign({}, question), {
          kind: "text",
          value: ""
        });
      }
      var intrangeMatch = question.kind.match(/intrange\[(-?[0-9]+)\.\.(-?[0-9]+)\]/);
      if (intrangeMatch && intrangeMatch[0] === question.kind) {
        var min = parseInt(intrangeMatch[1]);
        var max = parseInt(intrangeMatch[2]);
        return __assign(__assign({}, question), {
          kind: "intrange",
          value: min - 1,
          min: min,
          max: max
        });
      }
      return __assign(__assign({}, question), {
        kind: "other",
        value: -1
      });
    })) || []),
    formState = _b[0],
    setFormState = _b[1];
  var onSubmit = function onSubmit(event) {
    event.preventDefault();
    onSubmitFeedback(filterFields().map(function (item) {
      return {
        questionId: item.id,
        answer: item.value
      };
    }));
    setFormState([]);
  };
  var _onChange = function onChange(key, newValue) {
    setFormState(function (prev) {
      return prev.map(function (item) {
        return item.id !== key ? item : __assign(__assign({}, item), {
          value: newValue
        });
      });
    });
  };
  var mapPoints = function mapPoints() {
    return awardedPoints === null || awardedPoints === void 0 ? void 0 : awardedPoints.map(function (point) {
      return React.createElement(StyledChip, {
        key: point,
        label: point,
        variant: "outlined"
      });
    });
  };
  var filterFields = function filterFields() {
    return formState.filter(function (item) {
      return item.kind === "intrange" && item.value >= item.min || item.kind === "text" && item.value.toString().trim() !== "";
    });
  };
  var isFeedbackQuestions = function isFeedbackQuestions() {
    return feedbackQuestions && feedbackQuestions.length > 0;
  };
  var mapQuestions = function mapQuestions() {
    return formState.map(function (question) {
      switch (question.kind) {
        case "intrange":
          {
            var marks = [{
              value: question.min - 1,
              label: "-"
            }];
            for (var i = question.min; i <= question.max; i++) {
              marks.push({
                value: i,
                label: i.toString()
              });
            }
            return React.createElement(Question, {
              key: question.id
            }, React.createElement(Typography, {
              gutterBottom: true
            }, question.question), React.createElement(Slider, {
              defaultValue: question.min - 1,
              valueLabelFormat: function valueLabelFormat(x) {
                return x < question.min ? null : x;
              },
              "aria-labelledby": "discrete-slider-custom",
              step: 1,
              marks: marks,
              min: question.min - 1,
              max: question.max,
              valueLabelDisplay: "auto",
              onChange: function onChange(e, value) {
                return _onChange(question.id, value);
              },
              style: {
                width: "100%"
              }
            }));
          }
        case "text":
          return React.createElement(Question, {
            key: question.id
          }, React.createElement(Typography, {
            gutterBottom: true
          }, question.question), React.createElement(TextareaAutosize, {
            "data-cy": "feedback-text",
            rowsMin: 5,
            rowsMax: 10,
            style: {
              width: "100%"
            },
            onChange: function onChange(e) {
              return _onChange(question.id, e.target.value);
            }
          }));
        default:
          return null;
      }
    });
  };
  return React.createElement(OverlayBox, null, React.createElement(HeaderWrapper, null, React.createElement(FeedbackTitle, null, t("feedbackTitle"), React.createElement(CloseButton, {
    onClick: onClose
  }, "\xD7")), (awardedPoints === null || awardedPoints === void 0 ? void 0 : awardedPoints.length) && awardedPoints.length > 0 && React.createElement(FeedbackText, null, t("pointsAwarded"), ": ", mapPoints())), isFeedbackQuestions() && React.createElement(Grid, {
    container: true,
    direction: "column"
  }, React.createElement(StyledSpan, null, t("pleaseGiveFeedback")), React.createElement(StyledOutput, null, React.createElement("form", {
    id: "feedback-form",
    onSubmit: onSubmit
  }, mapQuestions()))), React.createElement(FooterWrapper, null, isFeedbackQuestions() && React.createElement(StyledButton, {
    form: "feedback-form",
    disabled: filterFields().length <= 0,
    "data-cy": "yes-feedback",
    type: "submit"
  }, t("button.send")), React.createElement(StyledButton, {
    onClick: onClose,
    "data-cy": "no-feedback"
  }, isFeedbackQuestions() ? t("dontSend") : t("button.close")), solutionUrl && React.createElement(StyledButton, {
    onClick: function onClick() {
      window.open(solutionUrl, "_blank");
    },
    style: {
      float: "right"
    }
  }, t("viewModelSolution"))));
};
export default FeedbackForm;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;